<template>
  <div>
    <Header/>
    <PremiumPurchasedModal
        v-show="showPremiumIsPurchased"
        v-on:closemodal="showPremiumIsPurchased = false"/>
    <GetPremiumModal v-if="showGetPremium"
                     :customer="accountData.customer"
                     v-on:closepremiummodal="onCloseModal"
                     v-on:premiumispurchased="onPurchasePremium"
                     v-on:updatesettings="saveAccountSettings"/>
    <GetPremiumModalAndroid v-if="showGetPremiumAndroid"
                            v-on:closepremiummodal="$router.back()" />
  </div>
</template>
<script>

import {API_HOST} from "@/helpers/stipe_const";
import {reportEvent} from "@/helpers/utils";
import {mapState} from "vuex";
import saveSetting from "@/components/mixins/saveSetting";
import Header from "@/components/Header";
import GetPremiumModalAndroid from "@/components/GetPremiumModalAndroid";
import GetPremiumModal from "@/components/GetPremiumModal";
import PremiumPurchasedModal from "@/components/PremiumPurchasedModal";
import { extensionLink } from '@/helpers/configs'

export default {
  name: 'GetTrialPremiumPage',
  mixins: [saveSetting],
  data() {
    return {
      subs: [],
      testPayment: localStorage.getItem('stripeTest'),
      showPremiumIsPurchased: false,
      showGetPremium: false,
      showGetPremiumAndroid: false,
      isAndroid: window.Android,
      redirectToExtension: this.$route.query.needext
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      accountData: state => state.accountData
    })
  },
  watch: {
    customer: function () {
      this.getSubs()
    }
  },
  created() {
    this.isAndroid ? this.showGetPremiumAndroid = true : this.showGetPremium = true
  },
  async mounted() {
    this.getSubs();
  },
  methods: {
    async cancel(id) {
      const cancelStatus = await fetch(`${API_HOST}/api/cancel-subscription?customerId=${this.accountData.customer.id}&subscriptionId=${id}${this.testPayment ? '&test=1' : ''}`, {}).then(r => r.json());
      if (cancelStatus) {
        reportEvent('cancelSubscription', {'email': this.user.email})
        await this.getSubs();
      }
    },
    async getSubs() {
      if (this.accountData.customer) {
        const subs = await fetch(`${API_HOST}/api/subscriptions?customerId=${this.accountData.customer.id}${this.testPayment ? '&test=1' : ''}`, {}).then(r => r.json());
        this.subs = subs.subscriptions ? subs.subscriptions.data : [];
      }
    },
    convertDate(unix_timestamp) {
      const date = new Date(unix_timestamp * 1000);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getUTCFullYear();

      return day + '/' + month + '/' + year;
    },
    onCloseModal(){
      this.redirectToExtension ? window.open(extensionLink) : this.$router.back()
    },
    onPurchasePremium(){
      this.redirectToExtension ? window.open(extensionLink) : this.showPremiumIsPurchased = true
    }
  },
  components: {
    Header,
    PremiumPurchasedModal,
    GetPremiumModalAndroid,
    GetPremiumModal
  }
}
</script>